import { HIDDEN_SPACE_KEY } from '../types/HIDDEN_SPACE_KEY';
import { Space } from '../types/Space';
import { spaceFactory } from './spaceFactory';

/**
 * Hidden space, explicitly to define content as hidden,
 * as opposed to an undefined space
 * @returns
 */
export const getHiddenSpace = (): Space => {
  return spaceFactory(HIDDEN_SPACE_KEY, false).get();
};
